import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Cloud } from "lucide-react";
import acmadLogo from '../images/acmadLogo.svg';
import "./styles/Header.css";





const Header = ({ isTranslucent }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const base_url_ = "https://ada.acmad.org/api/main/";
  const headerClasses = `navbar is-fixed-top ${
    isTranslucent ? "header--translucent" : ""
  } figma-header`;

  const toggleNavbar = () => setIsMenuOpen((v) => !v);

  const renderLink = (to, name, isExternal = false) => {
    if (isExternal) {
      return (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          className="navbar-item navLink"
          onClick={() => setIsMenuOpen(false)}
        >
          {name}
        </a>
      );
    }

    return (
      <NavLink
        to={to}
        className={({ isActive }) =>
          isActive ? "navbar-item activeLink" : "navbar-item navLink"
        }
        onClick={() => setIsMenuOpen(false)}
      >
        {name}
      </NavLink>
    );
  };

  return (
    <nav className={headerClasses} role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        {/* Figma-style brand */}
        <div className="brand-block">
          <Cloud className="brand-icon" />
          <div className="brand-text">
            <h1 className="brand-title">Africa Drought</h1>
            <p className="brand-subtitle">Monitoring and Advisory</p>
          </div>
        </div>

        {/* Burger */}
        <a
          role="button"
          className={`navbar-burger ${isMenuOpen ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded={isMenuOpen}
          onClick={toggleNavbar}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div className={`navbar-menu  ${isMenuOpen ? "is-active" : ""}`}>
        <div className="navbar-start custom-navbar-start ml-auto">
          {renderLink("/", "HOME")}
          {renderLink("/geoportal", "GEOPORTAL")}
          {/* drought-chat is served by the Next.js app (chat_frontend/) behind
              nginx, not by this SPA — force a real navigation, not a client route. */}
          <a
            href="/drought-chat"
            className="navbar-item navLink"
            onClick={() => setIsMenuOpen(false)}
          >
            DROUGHT-CHAT
          </a>
          {renderLink(`${base_url_}indicators`, "INDICATORS", true)}
          {renderLink(`${base_url_}about`, "ABOUT", true)}
          {renderLink(`${base_url_}partners`, "PARTNERS", true)}
          {renderLink(`${base_url_}get-in-touch`, "CONTACT", true)}
          {renderLink(`${base_url_}bulletins`, "BULLETINS", true)}
          <a
            href={`${base_url_}subscribe`}
            target="_blank"
            rel="noopener noreferrer"
            className="subscribe-cta"
            onClick={() => setIsMenuOpen(false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:"5px"}}><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/></svg>
            SUBSCRIBE
          </a>
        </div>

        {/* Removed: navbar-end logos */}
        <div className="navbar-end">
          <div className="logo">
            <img src={acmadLogo} alt="ACMAD Logo" />
            
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
